import { Empregador } from "../model/empregador";
import { OperacaoParcelaFinanceiraEmpregador } from "../model/operacaoParcelaFinanceiraEmpregador";

export class BaixaParcelaFinanceiraPorEmpregadorDTO {
  public idEmpregador!: String;
  public parcelas!: OperacaoParcelaFinanceiraEmpregador[];
  public isFinanceiro!: string;
  public valorFinal!: number;
  public totalParcelas!: number;
  public totalFinanceiro!: number;
  public totalNaoFinanceiro!: number;
  public saldoTotal!: number;
  public valorPago!: number;
  public dtMovimento!: Date;
  public valorMovimento!: number;
  public movimento!: string;
  public idHistoricoFinanceiro!: number | null;
  public confirmarValorPagoInferiorTotal?: boolean;
  public vencimento!: string;

  public bloqueioPropostaEsteira!: number;
}
